/**
 * Deprecated, but still in use 03.10.2016
 * The old to someday, hopefully be deprecated Jquery UI Popup Manager
 * If creating new modal use ModalManager instead.
 */
var VRC = VRC || {};

VRC.PopupManager = (function(){

    var $popup;
    var defaults = {
            autoOpen: false,
            modal: true,
            closeOnEscape: false,
            width: 800,
            height: 'auto',
            title: 'WELS Info',
            resizable: true,
            dialogClass: "dialogClass",
            beforeClose: function(event, ui) { $popup.html('');}
    };

    var init = function(){
        $popup = $('#generic_popup')
    };

    var showPopup = function(content, options){
        var settings = $.extend(true, defaults, options);
        $popup.dialog(settings);
        $popup.html(content);
        $popup.dialog('open');
    };

    return {
        init : init,
        show : showPopup
    }
})();